<template>
    <span v-if="icon == 'no-sort'" key="no-sort" class="d-flex flex-column sort-icon-container">
            <app-icon name="arrow-up" class="size-10"/>
            <app-icon name="arrow-down" class="size-10"/>
    </span>
    <span v-else :key="icon+'-sort'" class="sort-icon-container">
        <app-icon :key="'arrow-'+icon" :name="'arrow-'+icon" class="size-10"/>
    </span>
</template>

<script>
    export default {
        name: "Sort",
        props:{
            icon: {
                required: true,
                type: String
            }
        }
    }
</script>

<style scoped>
    .sort-icon-container {
        line-height: 0.5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .size-10 {
        width: 10px !important;
        height: 10px !important;
    }
</style>
